import { render, staticRenderFns } from "./MainProfile.vue?vue&type=template&id=407b0bb6&scoped=true&"
import script from "./MainProfile.vue?vue&type=script&lang=js&"
export * from "./MainProfile.vue?vue&type=script&lang=js&"
import style0 from "./MainProfile.vue?vue&type=style&index=0&id=407b0bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b0bb6",
  null
  
)

export default component.exports